<template>
    <div v-if="breadcrumbs" :class="['visual-breadcrumbs', modify]">
        <button
            :class="['button-circle', 'visual-breadcrumbs__back',
            {'button-circle_theme_stroke':  dataStep.step !== 'flat' },
            {'button-circle_theme_stroke-dark':  dataStep.step === 'flat' }
        ]"
            @click="goBack"
        >
            <iconArrowLeft />
        </button>
        <ul class="visual-breadcrumbs__list">
            <li v-for="item in breadcrumbs" class="visual-breadcrumbs__item" :key="item.id">
                <router-link class="visual-breadcrumbs__link" :to="item.link">
                    <div class="visual-breadcrumbs__top">
                        <span class="visual-breadcrumbs__text">{{item.name}}</span>
                        <iconArrowRight className="visual-breadcrumbs__arrow" />
                    </div>
                    <div class="visual-breadcrumbs__info">{{item.info}}</div>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<style lang='scss'>
    @import './Breadcrumbs.scss';
</style>

<script>
import iconArrowLeft from '../Icons/icon-arrow-left';
import iconArrowRight from '../Icons/icon-arrow-right';
import {mapGetters} from 'vuex';

export default {
    props: ['modify'],

    components: {
        iconArrowRight,
        iconArrowLeft
    },

    computed: {
        ...mapGetters({
            breadcrumbs: 'GET_BREADCRUMBS',
            dataStep   : 'GET_DATA_STEP'
        })
    },

    methods: {
        goBack() {
            window.history.back();
        }
    }
};
</script>
